
import { defineComponent, onMounted, ref, computed, watch } from "vue";
import AdminForm from "@/components/AdminForm.vue";
import store from "@/stores";
import {
  IMaintainer,
  ErrorMessageFilter,
  IErrorResponse,
  isErrors,
  consts,
} from "../services/Models";
import { AxiosResponse } from "axios";

export default defineComponent({
  name: "AdminUsers",
  components: {
    AdminForm,
  },
  setup() {
    const resource = store.useResource();
    const currentMaintainers = computed(() => {
      return resource.data.maintainers.map((x) => x.email).join(", ");
    });
    const errors = ref<IErrorResponse[]>([]);
    const errorMessages = computed(() => ({
      maintainers: ErrorMessageFilter(errors.value, "Mail"),
    }));

    // 管理者メールアドレス更新
    const update = () => {
      const maintainers = users.value
        .split(",")
        .filter((x) => x)
        .map<IMaintainer>((x) => ({
          id: undefined,
          email: x.trim(),
        }));

      resource
        .saveMaintainers(maintainers)
        .then(() => (errors.value = []))
        .catch((ex: AxiosResponse) => {
          if (isErrors(ex.data)) {
            errors.value = ex.data as IErrorResponse[];
          } else {
            alert(consts.updateMaintainersMailFailure);
          }
        });
    };
    watch(
      () => resource.data.maintainers,
      (newValue) => {
        users.value = newValue.map((x) => x.email).join(", ");
      }
    );

    const users = ref("");
    onMounted(() => {
      users.value = resource.data.maintainers.map((x) => x.email).join(", ");
    });

    return {
      update,
      users,
      currentMaintainers,
      errorMessages,
    };
  },
});
